import React from 'react';

import LogoTIWithIconTI from './Images/Rebranding/LogoTIWithIconTI';

interface TIHeaderProps {
  currentUserName: string;
  isLoggedIn: boolean;
  newsletterLandingPath: string;
  newsletterLogo: string;
  newSessionPath: string;
  rootPath: string;
}

const TIHeader = ({
  newSessionPath,
  currentUserName,
  rootPath,
  newsletterLandingPath,
  newsletterLogo,
  isLoggedIn,
}: TIHeaderProps) => {
  let link;

  if (isLoggedIn) {
    link = <a href={rootPath}>Welcome, {currentUserName}</a>;
  } else {
    link = (
      <a href={newSessionPath} className="sign-in-link">
        Sign In
      </a>
    );
  }

  return (
    <div className="rc-ti-header-wrapper">
      <div className="rc-newsletter-header">
        <div className="ti-logo-wrapper">
          <a href={rootPath}>
            <LogoTIWithIconTI />
          </a>
        </div>
        <div className="newsletter-logo-wrapper">
          <a href={newsletterLandingPath}>
            <img src={newsletterLogo} />
          </a>
        </div>
        <div className="sign-in">{link}</div>
      </div>
    </div>
  );
};

export default TIHeader;
